import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

import { useMobileAppName } from '../../hooks/use-mobile-app-name'
import { getAuthConfig } from './utils'

const DownloadApp = ({ content, customConfig }) => {
  const { t } = useTranslation(['auth'])
  const authConfig = getAuthConfig(window.location.hostname)
  const appName = useMobileAppName()

  const headerLogoImageSrc = customConfig ? customConfig.headerLogoImageSrc : authConfig.appLogo
  const headerAppName = customConfig ? customConfig.headerAppName : appName
  const googleLink = customConfig ? customConfig.googleStoreLink : authConfig.playStore
  const appleLink = customConfig ? customConfig.appleStoreLink : authConfig.appStore

  return (
    <div className="auth__success__cta">
      <img src={headerLogoImageSrc} className="auth__success__cta__app-logo" alt={headerAppName} />
      <h3>{t('auth:downloadApp.title', { appName: headerAppName })}</h3>
      <p>{content}</p>
      <div className="auth__badges-wrapper">
        {googleLink && (
          <a className="auth__badge" target="_blank" rel="noreferrer" href={googleLink}>
            <img src="/images/get-google-play-app.svg" alt={t('auth:layout.googlePlayAlt')} />
          </a>
        )}
        {appleLink && (
          <a className="auth__badge" target="_blank" rel="noreferrer" href={appleLink}>
            <img src="/images/get-appstore-app.svg" alt={t('auth:layout.appStoreAlt')} />
          </a>
        )}
      </div>
      <div className="auth__success__cta__powered">
        <span>{t('auth:downloadApp.poweredBy')}</span>
        <img src="/images/logo/elevateos-logo-wide-black.svg" alt={ELEVATEOS_LOGO_ALT} />
      </div>
    </div>
  )
}

DownloadApp.propTypes = {
  content: PropTypes.string,
  customConfig: PropTypes.object,
}

export default DownloadApp
